import { Story } from '../../types/story';

export const londonNeighbor: Story = {
  id: 'london-neighbor',
  title: 'The Key Under the Mat',
  excerpt: 'A nineteen-year-old university student gets locked out of his London flat, only to discover that his thirty-five-year-old neighbor has a key to more than just her apartment.',
  city: 'London',
  publishDate: '2026-01-16',
  readTime: '22 min read',
  tags: ['♂♀', 'age-gap', 'neighbor', 'intense', 'seduction'],
  categories: ['forbidden'],
  intensity: 3,
  content: `The problem with being nineteen is that you think you know everything. The problem with being nineteen and living alone for the first time is that you quickly discover you know nothing at all.

"Fuck, fuck, fuck," I muttered, patting down my pockets for the third time. No keys. No wallet. Just my phone with 12% battery and a growing sense of panic.

I was locked out of my flat in Hackney. It was 11 PM, raining, and I'd just gotten back from a disastrous first date with a girl from my literature class who'd spent the entire evening explaining why my favorite authors were problematic.

I could call my landlord, but he'd charge me £50 for an after-hours call-out. I could call my parents, but they'd lecture me about responsibility for twenty minutes before helping. Or I could—

"Lost something?"

I looked up. Mrs. Davenport was standing in her doorway, holding a glass of red wine, wearing a silk robe that was probably more expensive than everything I owned combined.

"My keys," I admitted, feeling my face heat up. "I think I left them on the kitchen counter."

She smiled, and it was the kind of smile that made my stomach do weird things. "Happens to the best of us, Leo. Come on in until you figure it out."

Mrs. Davenport—Eleanor—was my neighbor. Thirty-five, divorced, worked in something vague but high-paying in the City. We'd exchanged pleasantries in the hallway a few times, but that was it. She was beautiful in that intimidating way older women have—confident, put-together, like she'd never had a panicked moment in her life.

Her flat was the mirror image of mine, but while mine was student chaos—books everywhere, dishes in the sink, clothes on the floor—hers was pristine. Minimalist furniture, art on the walls that probably cost more than my tuition, a view of London that made my cheap student accommodation feel like a closet.

"Wine?" she asked, already pouring a second glass.

"I'm nineteen," I said, like that mattered.

"I won't tell if you don't."

I took the glass, my hand shaking slightly. Her fingers brushed mine, and I felt a jolt that had nothing to do with static electricity.

"So," she said, settling onto her sofa and patting the cushion next to her. "Tell me about this disastrous date."

I sat down, keeping a careful distance. "She was... intense. Very political. Very sure of herself."

"Sounds intimidating."

"She was. But also... boring? Like she'd memorized all the right opinions but didn't actually think about any of them."

Eleanor laughed, and it was a real laugh, not the polite laugh I was used to from women my age. "Oh, I know the type. They're the worst."

We talked for a while—about my classes at King's College, about her job in finance, about the ridiculous London rent prices. With each glass of wine, I felt more relaxed, more confident. More like I could actually have an intelligent conversation with a woman without making a fool of myself.

"You know," she said, swirling the wine in her glass, "when I was your age, I was dating boys who thought 'foreplay' was telling me I had nice eyes."

I choked on my wine. "I—uh—"

She laughed. "Relax, Leo. I'm not going to eat you. Unless you want me to."

The air in the room shifted. Suddenly I was very aware of her—of the way her silk robe had slipped slightly off one shoulder, of the scent of her perfume (something expensive and floral), of the fact that we were alone in her flat at midnight.

"Eleanor—"

"You know what I miss about being nineteen?" she said, setting her glass down and moving closer. "The enthusiasm. The way you want everything so badly. The way your body responds to... everything."

Her hand was on my thigh now, high enough that I could feel the heat of it through my jeans.

"I should probably go," I said, but I didn't move.

"Go where? You're locked out, remember?" Her other hand came up to my face, her fingers tracing my jawline. "And besides... I think you want to stay."

I did. God, I did. I wanted to stay more than I'd wanted anything in my nineteen years.

"Have you ever been with an older woman, Leo?" she whispered.

I shook my head, unable to speak.

"Good." She leaned in, her lips brushing against my ear. "I like being the first."

Then she kissed me.

It wasn't like kissing girls my age, who were either tentative or trying too hard. Eleanor kissed like she knew exactly what she was doing, like she'd had years of practice and enjoyed every minute of it. Her mouth was soft, confident, her tongue exploring mine like she was mapping a new territory.

My hands found her waist, pulling her closer, and she made a small sound of approval against my lips. I could feel myself getting hard, could feel the desperation building in me—the desperate need of a teenage boy who'd never really been touched.

"Easy," she murmured, pulling back slightly. "We have all night."

She stood up, held out her hand. "Come on."

I followed her to her bedroom, my heart pounding so hard I thought it might burst out of my chest. Her room was as perfect as the rest of her flat—a king-sized bed with expensive-looking sheets, more art on the walls, a view of the city lights that made everything feel surreal.

She turned to face me, her hands finding the hem of my t-shirt. "Let's see what we're working with."

She pulled it over my head, and I stood there, half-naked and self-conscious, while she looked me over. I was skinny, all lanky limbs and not much muscle, but she didn't seem to mind.

"You're beautiful," she said, and the word made me blush. "All long and lean like a young god."

Her hands were on my chest, her fingers tracing the lines of my ribs. I was trembling, and she could feel it.

"Nervous?" she asked.

"A little."

"Don't be. I'll take care of you."

She kissed me again, slower this time, her hands exploring my body with practiced confidence. When her fingers found the button of my jeans, I gasped.

"Is this okay?" she asked.

"God, yes."

She undid my jeans, pushed them down, and I was standing there in my boxers, my cock already hard and straining against the fabric.

"Someone's eager," she murmured, her hand cupping me through the thin cotton.

I couldn't answer, could only make some embarrassing sound that was half groan, half whimper.

She laughed, low and dark. "I love that. I love how responsive you are. How desperate."

She pushed my boxers down, and I was completely naked in front of her. I'd been naked in front of girls before, but this was different. This was... intense.

"Perfect," she whispered, and then she was kneeling in front of me.

The first touch of her tongue was electric. I'd had blowjobs before—clumsy, awkward attempts from girls who were clearly doing it because they thought they were supposed to. But Eleanor... Eleanor knew what she was doing.

She took me in deep, her lips sealing around the base, her tongue working the underside. I tangled my fingers in her hair, my knees actually shaking, and I had to brace myself against the wall to stay upright.

"Fuck," I breathed. "Eleanor—"

She pulled off just long enough to look up at me. "Don't hold back. I want to hear you."

She went back to work, her mouth hot and wet, her hand cupping my balls, squeezing just enough to make my eyes roll back in my head. I was already close—embarrassingly close—but I couldn't help it. I was nineteen, and a beautiful older woman was on her knees in front of me, and I was about to come in about thirty seconds.

"I'm going to—" I gasped.

"Come for me," she murmured around my cock. "Let me taste you."

That was it. That was all it took. I came hard, harder than I'd ever come in my life, my body arching, my release spilling into her mouth. She took it all, swallowing like it was the most natural thing in the world.

When I could finally stand again, she stood up, kissed me deep so I could taste myself on her tongue.

"Wow," I managed to say.

"We're not done yet," she said, a smirk playing on her lips. "That was just the appetizer."

She undressed slowly, letting me watch. Her body was incredible—full breasts, a narrow waist, hips that curved in just the right way. She wasn't skinny like the girls my age; she was a woman, with curves and confidence that made my mouth go dry.

"Your turn," she said, lying back on the bed. "Show me what you've learned."

I moved over her, my hands shaking slightly as I explored her body. I'd done this before, but never with someone this experienced, never with someone who actually seemed to be enjoying herself.

"Lower," she gasped when I kissed my way down her stomach. "Lower still."

I moved between her legs, and the scent of her arousal made my head spin. I'd gone down on girls before, but always awkwardly, never really knowing what I was doing. But with Eleanor, I felt like I had a guide.

"Like this," she murmured, her hand finding my hair, guiding me. "Slow circles. Yes, just like that."

I followed her instructions, learning what she liked, what made her gasp, what made her hips lift off the bed. When I added my fingers, curving them inside her, she cried out.

"God, yes. Right there. Don't stop."

I didn't stop. I kept going, my tongue and fingers working together, until she came with a cry that was probably loud enough to wake the neighbors. I didn't care. I wanted them to hear. I wanted everyone to know that I'd made this beautiful woman come.

"Condom?" she asked when she could finally speak again.

"Wallet. Jeans. Living room."

"I've got some," she said, reaching into her nightstand. "Just in case."

She rolled it on me, then pulled me down, guided me inside her. We both groaned as I filled her, and I had to stop for a moment, overwhelmed by the sensation.

"Don't be gentle," she whispered. "I want to know what it feels like to be fucked by a nineteen-year-old."

I didn't need to be told twice. I started moving, my hips finding a rhythm that was somewhere between desperate and confident. She met me thrust for thrust, her legs wrapped around my waist, her nails digging into my back.

"Harder," she gasped. "Give me everything."

I gave her everything—all the frustration of my disastrous date, all the desperation of being nineteen and horny all the time, all the awe of being with someone who actually knew what she wanted. I fucked her like my life depended on it, like this was the only chance I'd ever get.

"Come with me," she commanded. "Come with me, Leo."

I did. I came hard, my release hitting me like a physical force, and she followed me over the edge, her body clenching around me, her cries filling the room.

We lay tangled together afterward, our bodies slick with sweat, the city lights twinkling outside her window.

"Wow," I said again, because it was the only word my brain could form.

"Wow indeed," she agreed, kissing my forehead. "You're a natural."

"Really?"

"Oh yeah. With the right teacher, you could be dangerous."

I looked at her—at her perfect body, at her confident smile, at the way she was looking at me like I was actually interesting, not just some kid who lived next door.

"Can I... can I see you again?" I asked. "Not just when I'm locked out?"

She laughed. "I was hoping you'd ask. But you have to promise me something."

"Anything."

"Promise me you won't lose your keys again just to get my attention."

I grinned. "I can't make any promises."

"Good boy," she said, pulling me closer. "I like a little rebellion."

The next morning, I woke up to find my keys on her nightstand, along with a note that read: "Call me. Eleanor."

I did call her. And I did see her again. A lot.

My landlord never did charge me for that after-hours call-out. But Eleanor taught me things that were worth way more than £50.

She taught me that experience matters, that confidence is sexy, that sometimes the best things in life are locked out of your flat and waiting in the neighbor's bed.

And she taught me that being nineteen isn't about knowing everything.

It's about finding someone who's willing to teach you.`
};
